import dayjs from 'dayjs'
import addWeekDays from './addWeekDays'

export default function getMinFetchDate() {
  return addWeekDays(dayjs(), 5).format('DD/MM/YYYY')
}
